module.exports = __webpack_public_path__ + "static/media/Imagen 97@2x.bb7f730f.png";